<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import { EDetectionsPerm } from '@/types/permissions/DetectionsPermissionsEnum'
import { ERentalsPerm } from '@/types/permissions/RentalsPermissionsEnum'
import DeviceAddDetectionAction from '@/views/DevicesView/components/DeviceAddDetectionAction.vue'
import DeviceEndRentalAction from '@/views/DevicesView/components/DeviceEndRentalAction.vue'
import { GridLayout, PermissionWrapper } from '@rfc/rfc-components-library'
import moment from 'moment'
import { computed } from 'vue'
import { useStore } from 'vuex'
import DeviceAssignCheckpointAction from './DeviceAssignCheckpointAction.vue'
import DeviceCreateRentalAction from './DeviceCreateRentalAction.vue'
import DeviceUpdateRentalAction from './DeviceUpdateRentalAction.vue'

const store = useStore()

type Props = {
    data?: DeviceModel
}
const props = defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
defineEmits<Emits>()

const organization_id = computed(() => store?.state.authentication.me?.organization_id)

const currentlyRent = computed(
    () =>
        props.data?.rental?.start_at &&
        props.data?.rental?.end_at &&
        moment().isAfter(moment.utc(props.data?.rental.start_at)) &&
        moment().isBefore(moment.utc(props.data?.rental.end_at))
)
</script>

<template>
    <GridLayout :maxItemPerRow="2" :gap="8" class="w-full" isResponsive>
        <DeviceAssignCheckpointAction :data="data" @refresh="$emit('refresh')" />
        <PermissionWrapper :permission="ERentalsPerm.RENTALS_EDIT">
            <DeviceCreateRentalAction
                v-if="!!(data?.device_id ?? data?.id)"
                :deviceId="data?.device_id ?? data?.id!"
                @refresh="$emit('refresh')" />
            <DeviceUpdateRentalAction
                v-if="
                    !!(data?.device_id ?? data?.id) &&
                    !!data?.rental?.id &&
                    currentlyRent &&
                    data?.rental?.renter?.organization_id !== organization_id
                "
                :data="{
                    start_at: data.rental.start_at,
                    end_at: data.rental.end_at
                }"
                :rentalId="data.rental.id"
                @refresh="$emit('refresh')" />
            <DeviceEndRentalAction
                v-if="currentlyRent && data?.rental"
                :rentalId="data?.rental.id"
                @refresh="$emit('refresh')" />
        </PermissionWrapper>
        <PermissionWrapper :permission="EDetectionsPerm.DETECTIONS_EDIT">
            <DeviceAddDetectionAction
                :deviceId="data?.device_id ?? data?.id!"
                :disabled="!data?.checkpoint?.id"
                @refresh="$emit('refresh')"
                class="w-full" />
        </PermissionWrapper>
    </GridLayout>
</template>
